import React, { useEffect, useState } from 'react';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';

/**
 * Component that displays a message when the device loses Wi-Fi connection
 * and automatically reloads the page when connection is restored
 */
const OfflineAlert = ({ autoReload = true }) => {
    const isOnline = useOnlineStatus();
    const [wasOffline, setWasOffline] = useState(false);

    useEffect(() => {
        console.log('?? OfflineAlert - Connection status changed:', isOnline ? 'ONLINE' : 'OFFLINE');
        
        if (!isOnline) {
            console.log('?? OfflineAlert - Displaying offline modal');
            setWasOffline(true);
        }

        // If connection is restored and autoReload is enabled, reload the page
        if (isOnline && wasOffline && autoReload) {
            console.log('?? OfflineAlert - Connection restored, reloading in 500ms...');
            // Add a small delay to ensure connection is stable
            setTimeout(() => {
                console.log('?? OfflineAlert - Reloading now!');
                window.location.reload();
            }, 500);
        }
    }, [isOnline, wasOffline, autoReload]);

    if (isOnline) {
        return null;
    }

    return (
        <div 
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            }}
        >
            <div 
                style={{
                    backgroundColor: 'white',
                    padding: '30px',
                    borderRadius: '10px',
                    maxWidth: '500px',
                    textAlign: 'center',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}
            >
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>
                    <i className="bi bi-wifi-off" style={{ color: '#dc3545' }}></i>
                </div>
                <h2 style={{ color: '#333', marginBottom: '15px', fontSize: '24px', fontWeight: 'bold' }}>
                    Kein WLAN
                </h2>
                <p style={{ color: '#666', fontSize: '16px', lineHeight: '1.5' }}>
                    Kein WLAN. Bitte verbinde dich erneut mit dem WLAN und lade die Seite neu.
                </p>
                <button 
                    onClick={() => {
                        console.log('?? Manual reload button clicked');
                        window.location.reload();
                    }}
                    className="btn btn-primary mt-3"
                    style={{ 
                        padding: '10px 30px',
                        fontSize: '16px'
                    }}
                >
                    Seite neu laden
                </button>
            </div>
        </div>
    );
};

export default OfflineAlert;
